<template>
  <div class="exam">
    <div class="container">
      <div
        v-if="examStart && questionsData.length"
        class="exam-container"
      >
        <div id="examMain" class="exam-main">
          <div class="exam-main__title">
            {{ $t('exam.currentQuestion', { current: questionIndex + 1 }) }}
          </div>
          <div class="exam-main__content">
            <div :key="currentTopic.questionId" class="exam-question">
              <div class="exam-question__tool">
                <span>{{ currentTopic.questionTypeName }}</span>
              </div>

              <div class="exam-question__title">
                <p v-html="convertBreakLine(currentTopic.questionName)" />
              </div>

              <div
                v-if="currentTopic.questionAudioPath || currentTopic.questionImagePath"
                class="exam-question__content"
              >
                <div
                  v-if="currentTopic.questionAudioPath"
                  class="exam-question__audio"
                >
                  <audio controls>
                    <source :src="currentTopic.questionAudioPath" />
                  </audio>
                </div>

                <div
                  v-if="currentTopic.questionImagePath"
                  class="exam-question__image"
                >
                  <img :src="currentTopic.questionImagePath" alt="">
                </div>
              </div>

              <div class="exam-question__list">
                <template v-for="(item, index) in currentTopic.answers">
                  <el-checkbox
                    v-if="item.answerName !== ''"
                    v-model="item.isAnswer"
                    :key="item.answerId"
                    :true-label="1"
                    :false-label="0"
                    class="exam-question__option"
                    @change="changeAnswer(item)"
                  >
                    ({{ index + 1 }}) {{ item.answerName }}
                  </el-checkbox>
                </template>
              </div>

              <div class="exam-question__buttonBox">
                <a
                  v-if="questionIndex !== 0"
                  class="exam-question__prev"
                  @click="handlePrevTopic"
                >
                  <span>{{$t('exam.button.previous')}}</span>
                </a>

                <a
                  v-if="questionIndex !== questionsData.length - 1"
                  class="exam-question__next"
                  @click="handleNextTopic()"
                >
                  <span>{{$t('exam.button.next')}}</span>
                </a>

                <!-- <a
                  v-if="questionIndex === questionsData.length - 1"
                  class="exam-question__submit btn btn-primary"
                  @click="handleToAnswer()"
                >
                  <span>送出試卷</span>
                </a> -->
              </div>
            </div>
          </div>
        </div>

        <div class="exam-list">
          <div class="exam-list__title">{{ $t('exam.questionList') }}</div>
          <div class="exam-sidebar__tabs">
            <button
              class="exam-sidebar__tab"
              :class="{ 'exam-sidebar__tab--active': courseType === 1 }"
              @click="courseType = 1"
            >
              <i class="el-icon-notebook-2"></i>
              <span>{{ $t('exam.questionList') }}</span>
            </button>
            <button
              class="exam-sidebar__tab"
              :class="{ 'exam-sidebar__tab--active': courseType === 2 }"
              @click="courseType = 2"
            >
              <i class="el-icon-circle-close"></i>
              <span>{{ $t('exam.unanswered') }}</span>
            </button>
            <button
              class="exam-sidebar__tab"
              :class="{ 'exam-sidebar__tab--active': courseType === 3 }"
              @click="courseType = 3"
            >
              <i class="el-icon-collection-tag"></i>
              <span>{{ $t('exam.marked') }}</span>
            </button>
          </div>

          <div
            v-if="questionsFilterData.length"
            class="exam-list__summary"
          >
            <i class="fa fa-th" aria-hidden="true" />
            <span>{{ summaryTime }}</span>
            <span>{{ summaryProcess }}</span>
          </div>

          <div class="exam-list__content">
            <template v-if="questionsFilterData.length">
              <div
                v-for="item in questionsFilterData"
                :key="`${item.seq}-${item.questionCode}`"
                class="exam-list__item"
                :class="{'exam-list__item--active': item.seq === questionIndex}"
              >
                <a
                  class="exam-list__item-text"
                  @click="handleShowTopic(item, item.seq)"
                >
                  <i
                    class="fa fa-check-circle"
                    :style="{ color: hasAnswer(item) ? '#67c23a' : '#c0c4cc' }"
                  />

                  <span>{{ $t('exam.currentQuestion', { current: item.seq + 1 }) }}</span>
                </a>

                <div class="exam-list__item-button">
                  <a @click="handleMark(item)">
                    <i
                      class="fa fa-tag"
                      :style="{ color: item.isMark ? '#ff6363' : '#c0c4cc' }"
                    />
                  </a>
                </div>
              </div>
            </template>

            <p v-else>{{ $t('learning.noData') }}</p>
          </div>

          <div class="exam-sidebar__actions">
            <button
              class="exam-sidebar__submit-btn"
              @click="handleToAnswer()"
            >
              <i class="el-icon-document-checked"></i>
              {{ $t('exam.submitPaper') }}
            </button>
          </div>
        </div>
      </div>

      <div v-else class="exam-empty">
        <i class="el-icon-document-delete"></i>
        <p>{{ $t('exam.message.noExamQuestions') }}</p>
      </div>
    </div>

    <el-dialog
      :title="$t('exam.endExam')"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :visible.sync="examDialogShow"
      class="exam-dialog"
      center
    >
      <span>{{ examDialogText }}</span>
      <span slot="footer" class="dialog-footer">
        <button
          type="button"
          class="btn btn-info"
          @click="finishExam()"
        >
          <span>{{ $t('common.button.confirm') }}</span>
        </button>

        <button
          v-if="examSubmit"
          type="button"
          class="btn btn-light ml-3"
          @click="cancelEvent()"
        >
          <span>{{ $t('common.button.cancel') }}</span>
        </button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { GetPracticeBreadcrumb } from '@/api/BuyPracticeApi';
import { Examination, SaveExamination } from '@/api/MemberExamination';

/* global $ */
export default {
  data() {
    return {
      courseType: 1,
      courseId: 0,
      subjectId: 0,
      currentTopic: {
        isMark: false,
        isFavorite: false,
        isMarkAnswer: false,
        isTrueAnswer: false,
        questionCode: '',
        questionId: 0,
        questionName: '',
        questionType: 0,
        questionTypeName: '',
        questionImagePath: '',
        questionAudioPath: '',
        questionsNote: '',
        recordNoteCount: 0,
        answers: [],
      },

      questionsData: [],
      questionIndex: 0,

      examLoading: true,
      examStart: false,

      examTimer: '',
      examTimeStart: '',
      examTimeEnd: '',
      examTimeDuration: 0,
      examTimeText: '--',

      examDialogShow: false,
      examDialogText: '',
      examSubmit: false,

      examForm: {
        // 課程
        courseId: 0,
        // 科目
        subjectId: 0,
        // 是否限時 0否 1是
        isLimitTime: 0,
        // 若限時給時間
        limitTime: 0,
        // 題目數量
        questionCount: 99999,
        // 難易度
        questionDifficulty: 999,
        // 是否選擇題庫
        categoryType: 0,
        // 題庫分類編號，可多個，否的話給空
        categoryIds: [],
        // 塞選的條件，可多個，否的話給空
        filters: [],
        // 難題目數量
        easyQuestionCount: 0,
        // 中題目數量
        mediumQuestionCount: 0,
        // 易題目數量
        difficultQuestionCount: 0,
        // 是否選擇知識點
        knowledgeType: 0,
        // 知識點分類編號，可多個，否的話給空
        knowledgeIds: null,
        //  固定給 true
        useDefaultLimit: true,
      },

      isSubmitting: false,
    };
  },
  created() {
    this.GetAll();
  },
  mounted() {
    window.addEventListener('beforeunload', this.beforeWindow);
  },
  beforeRouteLeave(to, form, next) {
    window.removeEventListener('beforeunload', this.beforeWindow);

    this.clearTimer();

    next();
  },
  computed: {
    summaryTime() {
      return this.$t('exam.time', { seconds: this.examTimeText });
    },
    summaryProcess() {
      let questionTotal = 0;

      if (!this._.isEmpty(this.questionsData)) {
        const data = this._.filter(this.questionsData, (item) => item.responderAnswers.length > 0);
        questionTotal = data.length;
      }

      return this.$t('exam.process', { progress: `${questionTotal}/${this.questionsData.length}` });
    },
    questionsFilterData() {
      const tmpQuestions = this._.filter(this.questionsData,
        (item) => this.courseType === 1
          || (this.courseType === 2 && item.responderAnswers.length === 0)
          || (this.courseType === 3 && item.isMark));

      return tmpQuestions;
    },
  },
  methods: {
    beforeWindow(e) {
      // eslint-disable-next-line no-alert
      if (!window.confirm()) {
        e.preventDefault();
        e.returnValue = '';
      }
    },
    GetPracticeBreadcrumb() {
      return new Promise((resolve, reject) => {
        const data = {
          courseId: this.courseId,
          subjectId: this.subjectId,
        };

        GetPracticeBreadcrumb(data)
          .then((response) => {
            if (response.data.statusCode === 0) {
              if (!this._.isEmpty(response.data.data)) {
                this.$emit('update:currentPage', [
                  {
                    name: 'learnings',
                    title: this.$t('route.title.myCourses'),
                    path: '',
                  },
                  {
                    name: 'learning',
                    title: `${response.data.data.courseName}`,
                    path: `/learning/${response.data.data.courseId}`,
                  },
                  {
                    name: 'practices',
                    title: this.$t('route.title.exam'),
                    path: `/practices/${response.data.data.courseId}`,
                  },
                  {
                    name: 'exam',
                    title: `${response.data.data.subjectName}`,
                    path: '',
                  },
                ]);
              }
            }

            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetAll() {
      this.courseId = this.$route.params?.id;
      this.subjectId = this.$route.params?.subjectId;

      if (!this.courseId || !this.subjectId) {
        this.$message({
          type: 'error',
          message: this.$t('exam.message.recordNotFound'),
        });

        return;
      }

      this.GetPracticeBreadcrumb()
        .then(() => {
          this.GetExamination();
        })
        .catch(() => {
          this.$router.replace('/error').catch();
        });
    },

    // 取得所有題目
    GetExamination() {
      const postData = {
        ...this.examForm,
        courseId: Number(this.courseId),
        subjectId: Number(this.subjectId),
      };

      Examination(postData)
        .then((response) => {
          if (response.data.statusCode === 0) {
            this.data = this._.cloneDeep(response.data.data);

            this._.forEach(this.data.questions, (item) => {
              this._.sortBy(item.answers, ['answerId']);
            });

            this._.forEach(this.data.questions, (item, index) => {
              this.$set(item, 'seq', index);
              this.$set(item, 'isMark', false);
            });

            this.questionsData = this._.cloneDeep(this.data.questions);

            this._.forEach(this.questionsData, (item) => {
              this._.forEach(item.answers, (answer) => {
                // eslint-disable-next-line no-param-reassign
                answer.isAnswer = 0;
              });
            });

            this.handleShowTopic(this.questionsData[0], 0);

            this.startTimer();

            this.examStart = true;
          }
        })
        .catch(() => {
          this.$router.replace('/error').catch();
        });
    },

    // 顯示選擇的題目在畫面上
    handleShowTopic(topic, index) {
      this.currentTopic = topic;
      this.questionIndex = index;

      this.$nextTick(() => {
        $('.exam-list__content').animate({
          scrollTop: 48 * this.questionIndex,
        }, 0);

        if ($(window).width() < 992) {
          $('html, body').animate({
            scrollTop: $('#examMain').offset().top - 62,
          }, 0);
        }
      });
    },
    changeAnswer(answerItem) {
      if (this.currentTopic.questionType === 1 && answerItem.isAnswer === 1) {
        this._.forEach(this.currentTopic.answers, (item) => {
          if (item.answerId !== answerItem.answerId) {
            // eslint-disable-next-line no-param-reassign
            item.isAnswer = 0;
          }
        });
      }

      this.currentTopic.responderAnswers = this._.chain(this.currentTopic.answers)
        .filter((item) => item.isAnswer === 1)
        .map('answerId')
        .value();
    },
    handlePrevTopic() {
      const index = this.questionIndex - 1;

      this.handleShowTopic(this.questionsData[index], index);
    },
    handleNextTopic() {
      const index = this.questionIndex + 1;

      this.handleShowTopic(this.questionsData[index], index);
    },
    hasAnswer(item) {
      return item.responderAnswers.length > 0;
    },

    startTimer() {
      this.examTimeStart = new Date();

      if (this.data.isLimitTime) {
        this.examTimeDuration = this.data.limitTime;
        this.examTimeEnd = new Date(this.examTimeStart.getTime() + this.examTimeDuration * 60000);
        this.setTimer();
      }
    },
    setTimer() {
      if (this.data.isLimitTime) {
        this.examTimeStart = new Date();
        this.examTimeDuration = this.data.limitTime;
        this.examTimeEnd = this.$moment(this.examTimeStart).add(this.examTimeDuration, 'minute');

        this.examTimer = setInterval(() => {
          const now = new Date();
          const timeLeft = this.$moment(this.examTimeEnd).diff(now);
          const timeLeftSeconds = this.$moment(timeLeft).format('ss');
          const timeLeftMinutes = this.$moment(this.examTimeEnd).diff(now, 'minutes');

          if (timeLeft <= 0) {
            this.clearTimer();
            this.examTimeText = '00:00';

            this.examDialogText = this.$t('exam.message.timeExpired');
            this.examDialogShow = true;

            this.SaveExamination();
          } else {
            this.examTimeText = `${timeLeftMinutes}:${timeLeftSeconds}`;
          }
        }, 1000);
      }
    },
    clearTimer() {
      clearInterval(this.examTimer);
    },

    SaveExamination() {
      this.isSubmitting = true;

      const examinationEndDate = new Date();

      const postData = {
        courseId: this.courseId,
        subjectId: this.subjectId,
        questionCount: this.data.questionCount,
        questionActualCount: this.data.questionActualCount,
        isLimitTime: this.data.isLimitTime,
        limitTime: this.data.limitTime,
        questionDifficulty: this.data.questionDifficulty,
        categoryType: this.data.categoryType,
        categoryIds: this.data.categoryIds,
        filters: this.data.filters,
        questions: this.questionsData,
        examinationStartDate: this.examTimeStart,
        examinationEndDate,
        easyQuestionCount: this.data.easyQuestionCount,
        mediumQuestionCount: this.data.mediumQuestionCount,
        difficultQuestionCount: this.data.difficultQuestionCount,
        knowledgeIds: this.data.knowledgeIds,
      };

      SaveExamination(postData)
        .then((response) => {
          if (response.data.statusCode === 0) {
            if (this.examSubmit) {
              this.$router.push(`/practices/examHistory/${this.courseId}/${this.subjectId}`);
            }

            return;
          }

          this.isSubmitting = false;

          this.$router.replace('/error').catch();
        });
    },
    handleToAnswer() {
      if (this.isSubmitting) {
        return;
      }

      this.examDialogText = this.$t('exam.message.confirmSubmit', {
        timeNotEnded: this.data.isLimitTime ? this.$t('exam.message.timeNotEnded') : '',
      });
      this.examSubmit = true;
      this.examDialogShow = true;
    },
    cancelEvent() {
      this.examDialogShow = false;
      this.examDialogText = '';
      this.examSubmit = false;
    },
    finishExam() {
      this.examDialogShow = false;

      if (this.isSubmitting) {
        this.$router.push(`/practices/examHistory/${this.courseId}/${this.subjectId}`);

        return;
      }

      if (this.examSubmit) {
        this.SaveExamination();
      }
    },
    handleMark(item) {
      // eslint-disable-next-line no-param-reassign
      item.isMark = !item.isMark;
    },
    convertBreakLine(text) {
      if (this._.isEmpty(text)) {
        return '';
      }

      return text.replaceAll('\n', '<br>');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_exam.scss';

// 只保留 Exam.vue 特定的樣式覆寫
.exam-question__option {
  cursor: pointer;

  &:hover {
    border-color: var(--primary-color);
    background-color: var(--primary-light-color);
  }
}

::v-deep .exam-dialog {
  .el-dialog {
    border-radius: var(--border-radius-lg);

    @media (max-width: 991px) {
      width: 90% !important;
      max-width: 500px;
    }

    @media (max-width: 575px) {
      width: 95% !important;
    }

    .el-dialog__header {
      padding: 20px 24px;
      border-bottom: 1px solid var(--border-lighter);

      @media (max-width: 575px) {
        padding: 16px 20px;
      }

      .el-dialog__title {
        color: var(--text-primary);
        font-size: 18px;
        font-weight: 600;

        @media (max-width: 575px) {
          font-size: 16px;
        }
      }

      .el-dialog__close {
        color: var(--text-white);

        &:hover {
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }

    .el-dialog__body {
      padding: 24px;
      font-size: 15px;
      line-height: 1.8;
      color: var(--text-regular);

      @media (max-width: 575px) {
        padding: 20px;
        font-size: 14px;
      }
    }

    .el-dialog__footer {
      padding: 16px 24px;
      border-top: 1px solid var(--border-lighter);

      @media (max-width: 575px) {
        padding: 12px 20px;
      }
    }
  }

  .btn {
    padding: 10px 24px;
    border-radius: var(--border-radius-base);
    font-size: var(--font-size-base);
    font-weight: 600;
    transition: all var(--transition-base);

    &-info {
      background-color: var(--primary-color);
      border-color: var(--primary-color);
      color: var(--text-white);

      &:hover {
        background-color: #0099d8;
        border-color: #0099d8;
      }
    }

    &-light {
      background-color: var(--background-base);
      border-color: var(--border-base);
      color: var(--text-regular);

      &:hover {
        background-color: var(--background-white);
        border-color: var(--primary-color);
        color: var(--primary-color);
      }
    }
  }
}
</style>
